export const COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN = 1;
export const MAGIC_LINK = 2;
export const COLLECT_CONTACT_ON_LAST_ONBOARDING_SCREEN = 3;
export const COLLECT_CONTACT_BEFORE_SCORE_INTRO = 4;
export const COLLECT_CONTACT_ON_ACTION_ITEMS = 5;
